// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Stopwatch = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Stopwatch = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Stopwatch = _exports.Stopwatch = function Stopwatch(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M14.6656 6.63584L15.4432 5.85836C15.6873 5.61419 15.6873 5.21833 15.4432 4.97416C15.199 4.73 14.8031 4.73 14.559 4.97416L13.7439 5.78918C12.5873 4.90585 11.1482 4.375 9.58398 4.375C5.79315 4.375 2.70898 7.45917 2.70898 11.25C2.70898 15.0408 5.79315 18.125 9.58398 18.125C13.3748 18.125 16.459 15.0408 16.459 11.25C16.459 9.47333 15.7756 7.85751 14.6656 6.63584ZM9.58398 16.875C6.48232 16.875 3.95898 14.3517 3.95898 11.25C3.95898 8.14833 6.48232 5.625 9.58398 5.625C12.6857 5.625 15.209 8.14833 15.209 11.25C15.209 14.3517 12.6857 16.875 9.58398 16.875ZM11.6256 12C11.9014 12.2075 11.9574 12.5991 11.7499 12.875C11.6283 13.0383 11.4399 13.125 11.249 13.125C11.119 13.125 10.9874 13.0841 10.8749 13L9.20821 11.75C9.05154 11.6316 8.95817 11.4467 8.95817 11.25V8.33333C8.95817 7.98833 9.23817 7.70833 9.58317 7.70833C9.92817 7.70833 10.2082 7.98833 10.2082 8.33333V10.9375L11.6256 12ZM6.87565 2.5C6.87565 2.155 7.15565 1.875 7.50065 1.875H11.6673C12.0123 1.875 12.2923 2.155 12.2923 2.5C12.2923 2.845 12.0123 3.125 11.6673 3.125H7.50065C7.15565 3.125 6.87565 2.845 6.87565 2.5Z",
      fill: "#212B36"
    }));
  };
});
